<a
  [hidden]="!showHelpCenterIcon"
  class="helpFont pl-2 text-decoration-none"
  target="_blank"
  [href]="pageUrl"
  ><i class="far fa-question-circle helpIcon" data-testid="help-center-icon"></i
  ><span class="text-decoration-undeline pl-2"
    >{{ displayText == '' ? '' : ('admin.store.help.helpText' | translate) }}
    {{ displayText | translate }}</span
  >
</a>
